var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChipDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54126 10.4009C7.85598 10.728 8.37947 10.728 8.69419 10.4009L12.0103 6.95468C12.4994 6.44643 12.1392 5.59998 11.4339 5.59998H4.80159C4.09627 5.59998 3.73608 6.44643 4.22513 6.95468L7.54126 10.4009Z",
    fill: "#7A7A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipDown);
export default __webpack_public_path__ + "static/media/chip-down.e3af262ccd9b67f5c708428d002559b8.svg";
export { ForwardRef as ReactComponent };